import { render, staticRenderFns } from "./PrivateParcel.vue?vue&type=template&id=9f1d54bc&scoped=true&"
import script from "./PrivateParcel.vue?vue&type=script&lang=js&"
export * from "./PrivateParcel.vue?vue&type=script&lang=js&"
import style0 from "./PrivateParcel.vue?vue&type=style&index=0&id=9f1d54bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1d54bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f1d54bc')) {
      api.createRecord('9f1d54bc', component.options)
    } else {
      api.reload('9f1d54bc', component.options)
    }
    module.hot.accept("./PrivateParcel.vue?vue&type=template&id=9f1d54bc&scoped=true&", function () {
      api.rerender('9f1d54bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateParcel.vue"
export default component.exports